export const FONT_SIZE = 14

export const PLAN_ITEM_OPACITY = 0.9
export const PLAN_ITEM_DRAGGING_OPACITY = 0.75

export const SNAP_GRID_SIZE = 2.5
export const VISIBLE_GRID_SIZE = 10

